/**
 * Všeobecné obchodní podmínky — hash-route #podminky.
 *
 * Storno podmínky, reklamace, odstoupení od smlouvy a údaje o poukazech jsou
 * převzaty z platných podmínek provozovatele (STALAGMIT, a.s.) zveřejněných
 * na sobacov.cz — nejsou vymyšlené. Doplněno o údaje k online platbě a ČOI.
 */

const BLOCKS: { title: string; body: React.ReactNode }[] = [
  {
    title: '1. Provozovatel',
    body: (
      <>
        <p>
          Provozovatelem Sportovního areálu Sobáčov a prodávajícím je{' '}
          <b>STALAGMIT, a.s.</b>, IČ 27377342, DIČ CZ27377342, se sídlem
          Varšavská 715/36, Vinohrady, 120 00 Praha 2.
        </p>
        <p className="mt-2">
          Provozovna a adresa pro doručování: Sobáčov 111, 783 21 Mladeč.
          Kontakt:{' '}
          <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
            rezervace.sobacov@gmail.com
          </a>
          , tel. +420 775 140 705 (recepce), +420 775 433 401 (rybolov, chatky a sport).
        </p>
      </>
    ),
  },
  {
    title: '2. Co si u nás rezervujete',
    body: (
      <>
        <p>
          Přes tento web rezervujete ubytování (rybářské chatky, tiny house, bivak,
          stání pro karavan), sportoviště (tenisový kurt, beach volejbal) a kupujete
          dárkové poukazy. Pokoje penzionu se rezervují na Booking.com, kam vás web
          přesměruje.
        </p>
        <p className="mt-2">
          Rybářské povolenky <b>nelze rezervovat předem</b> — vystavujeme je na místě
          a hradí se hotově nebo kartou.
        </p>
      </>
    ),
  },
  {
    title: '3. Vznik rezervace',
    body: (
      <>
        <p>
          Rezervaci vytvoříte vyplněním formuláře na webu. Před odesláním máte možnost
          zkontrolovat a opravit zadané údaje. Odesláním formuláře se rezervace stává
          závaznou nabídkou.
        </p>
        <p className="mt-2">
          Smluvní vztah vzniká potvrzením rezervace ze strany provozovatele (SMS nebo
          e-mailem), případně připsáním platby, je-li vyžadována předem. Provozovatel
          je oprávněn rezervaci dodatečně ověřit telefonicky.
        </p>
      </>
    ),
  },
  {
    title: '4. Ceny a platba',
    body: (
      <>
        <p>
          Ceny jsou uvedeny na webu v korunách českých a platí po dobu, kdy jsou
          zobrazeny. Sportoviště se hradí 100 % předem online, u ubytování si
          provozovatel vyhrazuje právo požadovat zálohu ve výši 30 % až 100 % ceny.
          Rezervace ubytování se stává závaznou po obdržení zálohy, není-li dohodnuto
          jinak.
        </p>
        <p className="mt-2">
          Online platby zajišťuje licencovaná platební brána pod dohledem České národní
          banky — Comgate a.s., IČ 27924505, Hradec Králové. Platit lze kartou
          (zabezpečeno standardem 3D Secure), Apple Pay, Google Pay nebo okamžitým
          převodem z internetového bankovnictví. Po dokončení platby jste přesměrováni
          zpět na náš web a rezervace je potvrzena.
        </p>
        <p className="mt-2">
          Zbývající částku za ubytování a čerpané služby hradíte nejpozději v den
          ukončení pobytu proti vyúčtování, po odečtení uhrazených záloh.
        </p>
      </>
    ),
  },
  {
    title: '5. Storno podmínky — ubytování',
    body: (
      <>
        <p>
          Zrušení rezervace komunikujte přímo s provozovatelem — písemně, elektronicky
          nebo telefonicky. Provozovatel je oprávněn účtovat storno poplatky a použít
          na ně složenou zálohu.
        </p>
        <p className="mt-3 font-semibold text-ink-900">Klasický pobyt (cena BAR)</p>
        <ul className="mt-2 space-y-1.5 list-disc list-inside">
          <li>nejpozději <b>14 dní před příjezdem</b> — zrušení i změna rezervace <b>zdarma</b></li>
          <li>méně než 14 dní před příjezdem nebo nedojezd (no-show) — storno poplatek <b>100 %</b> z celého pobytu</li>
        </ul>
        <p className="mt-2">
          <b>Nevratné rezervace (Non-Refundable) a akce First Minute se slevou:</b>{' '}
          celková částka je účtována v den vytvoření rezervace a je nevratná; změny
          nejsou možné.
        </p>
        <p className="mt-2">
          <b>Pobyty se slevou a pobytové balíčky:</b> zrušení nejpozději 7 dní před
          příjezdem, jinak storno poplatek 50 % z celého pobytu.
        </p>
        <p className="mt-2 text-[13px] text-ink-700">
          Depozit a rezervační poplatek (byly-li účtovány) jsou nevratné. Při zkrácení
          pobytu nebo jiné změně ze strany klienta má provozovatel právo vyúčtovat plnou
          cenu za celou původně sjednanou délku pobytu.
        </p>
      </>
    ),
  },
  {
    title: '6. Storno podmínky — skupiny a akce',
    body: (
      <>
        <ul className="space-y-1.5 list-disc list-inside">
          <li>90–65 dní před příjezdem lze zdarma zrušit 20 % ze smluvní kapacity</li>
          <li>64–40 dní — zdarma 15 % ze zbývající kapacity</li>
          <li>39–24 dní — zdarma 10 % ze zbývající kapacity</li>
          <li>23–13 dní — zdarma 5 % ze zbývající kapacity</li>
          <li>méně než 13 dní a při nedojezdu (no-show) — storno zdarma nelze uplatnit, účtuje se plná smluvní částka</li>
        </ul>
        <p className="mt-2">
          Při zrušení nebo redukci nad uvedený rámec se účtují převyšující položky
          v jejich smluvní hodnotě. Platební podmínky skupinových akcí se sjednávají
          individuálně podle termínu akce.
        </p>
      </>
    ),
  },
  {
    title: '7. Sportoviště — přesun a zrušení',
    body: (
      <>
        <p>
          Sportovní rezervace se hradí 100 % předem. Termín lze <b>jednou</b> přesunout
          nejpozději 2 hodiny před začátkem, a to z odkazu nebo kódu v potvrzovací SMS;
          použije se stejné sportoviště a stejná zaplacená cena.
        </p>
        <p className="mt-2">
          Zrušíme-li rezervaci kvůli nepříznivému počasí, obdržíte voucher v hodnotě
          100 % na další rezervaci stejného sportu s platností 90 dní. Voucher nelze
          proplatit v hotovosti. Podrobnosti najdete v{' '}
          <a href="#pravidla" className="font-semibold text-ink-900 hover:text-brand-600">
            Pravidlech rezervace
          </a>.
        </p>
      </>
    ),
  },
  {
    title: '8. Dárkové poukazy',
    body: (
      <>
        <p>
          Dárkové poukazy prodáváme elektronicky; po zaplacení obdržíte SMS s unikátním
          kódem a datem platnosti. Poukaz se uplatňuje na ubytování, rybolov a další
          služby areálu a jeho pravost se ověřuje na místě.
        </p>
        <p className="mt-2">
          <b>Platnost poukazu je 1 rok (365 dní) od zaplacení.</b> Po uplynutí platnosti
          poukaz propadá bez náhrady. Poukaz lze uplatnit jednorázově; nevyčerpaný
          zůstatek se nevrací ani nepřevádí na další pobyt.
        </p>
        <p className="mt-2">
          Poukaz není ceninou, je neprodejný a nelze jej použít opakovaně. Od smlouvy
          lze odstoupit a poukaz vrátit do čtrnácti dnů ode dne, kdy byla plná částka
          připsána na účet provozovatele; kód bude zneplatněn a objednateli se vrátí
          zaplacená částka. Nárok na vrácení má pouze objednatel. U již uplatněného
          poukazu odstoupení není možné. Žádost zašlete na{' '}
          <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
            rezervace.sobacov@gmail.com
          </a>{' '}
          s údaji o objednávce.
        </p>
      </>
    ),
  },
  {
    title: '9. Odstoupení od smlouvy',
    body: (
      <>
        <p>
          U zboží zakoupeného na dálku máte podle § 1829 odst. 1 občanského zákoníku
          právo odstoupit od smlouvy do čtrnácti dnů od převzetí. Odstoupení zašlete na
          adresu provozovny nebo na{' '}
          <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
            rezervace.sobacov@gmail.com
          </a>
          . Peněžní prostředky vrátíme do čtrnácti dnů stejným způsobem, jakým jsme je
          přijali.
        </p>
        <p className="mt-2">
          <b>Pozor:</b> podle § 1837 občanského zákoníku nelze odstoupit od smlouvy
          o využití volného času, ubytování, stravování nebo dopravy, pokud je plnění
          poskytováno v určeném termínu. Na rezervace pobytu, sportoviště a rybolovu
          se proto čtrnáctidenní lhůta nevztahuje — řídí se storno podmínkami výše.
        </p>
      </>
    ),
  },
  {
    title: '10. Reklamace',
    body: (
      <>
        <p>
          Reklamaci uplatněte písemně na{' '}
          <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
            rezervace.sobacov@gmail.com
          </a>{' '}
          s uvedením čísla objednávky a popisem vady. Nejrychleji vyřídíme reklamaci
          osobně v areálu (Sobáčov 111, Mladeč).
        </p>
        <p className="mt-2">
          Při oprávněné reklamaci máte právo na odstranění vady, a není-li to možné, na
          přiměřenou kompenzaci, výměnu nebo vrácení peněz. Reklamace se nevztahuje na
          vady způsobené nesprávným skladováním nebo mechanickým poškozením ze strany
          zákazníka.
        </p>
      </>
    ),
  },
  {
    title: '11. Ubytovací a provozní řád',
    body: (
      <>
        <p>
          Host je povinen dodržovat provozní řád areálu a pravidla rybolovu. Pro rybolov
          platí samostatná{' '}
          <a href="#pravidla-rybolov" className="font-semibold text-ink-900 hover:text-brand-600">
            Pravidla rybolovu
          </a>{' '}
          (povolenka, lovná místa, manipulace s rybou, noční klid od 22:00).
        </p>
        <p className="mt-2">
          Časy příjezdu a odjezdu jsou uvedeny v sekci{' '}
          <a href="#info-prijezd" className="font-semibold text-ink-900 hover:text-brand-600">
            Příjezd &amp; odjezd
          </a>{' '}
          a u každého typu ubytování.
        </p>
      </>
    ),
  },
  {
    title: '12. Mimosoudní řešení sporů',
    body: (
      <p>
        Jste-li spotřebitel a vznikne mezi námi spor, který se nepodaří vyřešit dohodou,
        máte právo obrátit se na subjekt mimosoudního řešení spotřebitelských sporů,
        kterým je <b>Česká obchodní inspekce</b> —{' '}
        <a href="https://coi.gov.cz/" target="_blank" rel="noopener" className="font-semibold text-ink-900 hover:text-brand-600">
          coi.gov.cz
        </a>
        . Řešení sporu je bezplatné a zahajuje se na návrh spotřebitele.
      </p>
    ),
  },
  {
    title: '13. Ochrana osobních údajů',
    body: (
      <p>
        Jak nakládáme s osobními údaji, popisují{' '}
        <a href="#gdpr" className="font-semibold text-ink-900 hover:text-brand-600">
          Zásady zpracování osobních údajů (GDPR)
        </a>
        .
      </p>
    ),
  },
]

export function Podminky() {
  return (
    <section className="bg-paper py-12 md:py-20 min-h-screen">
      <div className="container-x max-w-3xl">
        <div className="text-[10px] uppercase tracking-[0.30em] text-brand-500 font-bold flex items-center gap-2">
          <span className="inline-block w-8 h-px bg-brand-500" />
          Sobáčov · Fishing &amp; Sport Resort
        </div>
        <h1 className="h-display text-4xl md:text-5xl mt-3">Obchodní podmínky</h1>
        <p className="text-ink-700 mt-3 text-sm">
          Všeobecné obchodní podmínky pro rezervace ubytování, sportovišť a nákup
          dárkových poukazů.
        </p>

        <div className="mt-10 space-y-8">
          {BLOCKS.map((b) => (
            <div key={b.title} className="card p-6 md:p-7">
              <h2 className="font-bold text-lg text-ink-900 tracking-tight">{b.title}</h2>
              <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">{b.body}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-[13px] text-ink-700">
          Tyto obchodní podmínky jsou účinné od 29. 9. 2026.
        </div>

        <a href="#top" onClick={() => { window.location.hash = '' }} className="btn-outline-dark mt-8">
          Zpět na hlavní stránku
        </a>
      </div>
    </section>
  )
}
